import { Modal, Typography, Divider } from 'antd';

const { Text, Paragraph } = Typography;

export const TemplatePreview = ({ open, onClose, subject, content }) => {
  const sampleData = {
    customer_name: 'John Doe',
    appointment_date: 'January 15, 2026',
    appointment_time: '10:00 AM',
    new_appointment_date: 'January 20, 2026',
    new_appointment_time: '2:00 PM',
    old_appointment_date: 'January 15, 2026',
    old_appointment_time: '10:00 AM',
    service_name: 'General Consultation',
    location: '123 Main Street, Suite 100',
    company_name: 'Your Company Name',
  };

  const replaceVariables = (text) => {
    return text.replace(/\{\{(\w+)\}\}/g, (match, key) => sampleData[key] || match);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Email Preview"
      footer={null}
      width={700}
      centered
    >
      <div className="pb-4 mb-4">
        <Text type="secondary" style={{ marginBottom: 4, display: 'block' }}>
          Subject:
        </Text>
        <Text strong>{replaceVariables(subject)}</Text>
      </div>
      
      <Divider style={{ margin: '16px 0' }} />
      
      <div 
        className="bg-background p-6 rounded-lg max-h-[500px] overflow-y-auto"
        style={{ 
          border: '1px solid #f0f0f0',
          backgroundColor: '#fafafa'
        }}
        dangerouslySetInnerHTML={{ __html: replaceVariables(content) }}
      />
      
      <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 16, marginBottom: 0 }}>
        * Variables like {'{{customer_name}}'} are replaced with sample data in this preview.
      </Paragraph>
    </Modal>
  );
};
